/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Flow_Item_No_LinkInputs */

const en_task_flow_item_no_link = /** @type {(inputs: Task_Flow_Item_No_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No link`)
};

const pt_br2_task_flow_item_no_link = /** @type {(inputs: Task_Flow_Item_No_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem link`)
};

/**
* | output |
* | --- |
* | "No link" |
*
* @param {Task_Flow_Item_No_LinkInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_item_no_link = /** @type {((inputs?: Task_Flow_Item_No_LinkInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_Item_No_LinkInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_item_no_link(inputs)
	return pt_br2_task_flow_item_no_link(inputs)
});